import type { Lucid } from '../types/types';

const getEntityFields = (node: Omit<Lucid.Drupal.Node, 'entityRevisions'>) => {
  const { entityMetatags, entitySchemaMetatags, entityTranslations } = node;

  const combinedTranslations = entityTranslations || [];
  const combinedEntityMetatags = entityMetatags || [];

  return {
    entityMetatags: combinedEntityMetatags as Lucid.Template.Metatag[],
    entitySchemaMetatags,
    // we have to cast this to Drupal_Node to include the extra fields
    // that are added in the query based on Drupal_Node values
    entityTranslations: combinedTranslations as Lucid.Drupal.ExtendedDrupalNode[],
  };
};

export default getEntityFields;
